//import React from 'react';
import ReactDOM from 'react-dom';
//import {BrowserRouter} from 'react-router-dom';
import './index.css';
//import App from './App';
import reportWebVitals from './reportWebVitals';
import CustomRoutes from "./router";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
//import Cookies from 'universal-cookie';
//const cookies = new Cookies();
ReactDOM.render(
/*}  <BrowserRouter>
  <App />
  </BrowserRouter>, */
  
        <CustomRoutes/>,
      document.getElementById('root')
  );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
